import {createGlobalStyle} from 'styled-components'
import {colors} from './sharedComponents/colors'

/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */
const normalize =
  'html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}main{display:block}h1{font-size:2em;margin:.67em 0}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details{display:block}summary{display:list-item}template{display:none}[hidden]{display:none}'

export const GlobalStyle = createGlobalStyle`
  :root{
    --navbar-height: 4rem;
  }
  body{
    /*font-family: 'HelveticaNeue', 'Helvetica Neue', Helvetica, Arial, 'FreeSans', sans-serif;*/
    font-family: FavoritStd-Book, monospace;
    color: ${colors.brand.cobalt};
    font-feature-settings: 'ss01' on, 'ss04' on, 'ss05' on;
  }
  *{
    box-sizing: border-box;
  }
  ${normalize}
  #react-root{
    background-color: ${colors.system.lightGrey_5};
  }
  button{
    cursor: pointer;
  }
  h1,h2,h3,h4,h5{
    margin: 0;
  }
  p{
    font-size: 1rem;
    line-height: 1.6;
  }
  ul{
    margin: 0;
    padding: 0;
  }
  a.unstyled{
    text-decoration: none;
    color: black;
    display: block;
    cursor: pointer;
  }
`
